/**
 * Whether the organization has a default project, as the fallback settings
 * tell a reader (#2870). A default project outside the reader's access comes
 * back without its id, flagged `defaultProjectHidden`: it is still set, so
 * unmatched records go to it and reject-unmatched stays in standby. One
 * reading for every screen that shows the routing fallback — the settings
 * section, a project's Routing tab and the pipeline status.
 */
import type { InboundRoutingFallbackSettings } from '@/lib/api/types/inbound-routing.types';

export interface DefaultProjectState {
  /** A default project is set, readable or not. */
  isSet: boolean;
  /** Set, but outside the reader's access: no id to show. */
  isHidden: boolean;
}

export function defaultProjectState(
  settings: InboundRoutingFallbackSettings | undefined
): DefaultProjectState {
  const isHidden = !settings?.defaultProjectId && !!settings?.defaultProjectHidden;
  return { isSet: !!settings?.defaultProjectId || isHidden, isHidden };
}
